/**
 * Parking-related constants
 */

export const PARKING_RESULT_CODE = {
    SCHEDULED_PARKING: 'E',
    RESULT_SUCCESS: 'S',
} as const;

export const CHEONGNYANGNI_SHOPPING_MALL_MAP_ID = 'e5430e7d-5e16-4ebc-bdd9-77d162a08fb2';
export const CHEONGNYANGNI_SHOPPING_MALL_STORE_CODE = '0411';
export const CHEONGNYANGNI_PRIORITY_STORE_CODES = ['0411', '0004'] as const;

export const isCheongnyangniShoppingMallParking = (mapId?: string, storeCode?: string) =>
    mapId === CHEONGNYANGNI_SHOPPING_MALL_MAP_ID && storeCode === CHEONGNYANGNI_SHOPPING_MALL_STORE_CODE;
